import React from 'react';

import logo from '../assets/images/logo.svg'

const Header = () => {
  return (
    <header>
      <div>
        <a className='logo-home' href="https://www.lvlcs.io" target="_blank">
          <img src={logo} alt='Love laces'/>
        </a>
        <nav>
          <a href="https://www.lvlcs.io" target="_blank">Home</a>
          <a href="https://www.lvlcs.io/lvlcs-faq" target="_blank">FAQ</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;